import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faEnvelope, faEnvelopeOpen, faMoneyCheckEdit } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { Email } from 'src/app/store/samwin/email/email-behaviour/email';
import { EmailBehaviourState } from 'src/app/store/samwin/email/email-behaviour/email-behaviour.state';
import { MessageInfo } from 'src/app/store/samwin/samwin-mail-list/message-info';
import { SamwinMessageListStateSelectors } from 'src/app/store/samwin/samwin-mail-list/samwin-message-list.selectors';
import { MailingFolderEnum } from 'src/app/store/samwin/samwin-skills/mailing-folders-enum';
import { RestoreWindow, SetWindowIndex } from 'src/app/store/utility/samweb-window/samweb-window.actions';
import { SamwebWindowState, WindowType, WindowTypes } from 'src/app/store/utility/samweb-window/samweb-window.state';

@Component({
   selector: 'samweb-email-list-item',
   templateUrl: './email-list-item.component.html',
   styleUrls: ['./email-list-item.component.scss'],
})
export class EmailListItemComponent implements OnInit, OnDestroy {
   private destroy$ = new Subject();

   @Input()
   public overlayIcon: IconDefinition;
   public envelope: IconDefinition = faEnvelope;
   public envelopeOpen: IconDefinition = faEnvelopeOpen;
   public skillTreeIcon: IconDefinition = faMoneyCheckEdit;

   public email$: Observable<Email>;
   public isOpen$: Observable<boolean>;
   public messageInfo$: Observable<MessageInfo>;

   @Input()
   public messageId: string;
   public type: WindowType = WindowTypes.Email;

   constructor(public store: Store) {}

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }

   ngOnInit() {
      this.email$ = this.store.select(EmailBehaviourState.getEmail).pipe(map((getMail) => getMail(this.messageId)));
      this.isOpen$ = this.store.select(SamwebWindowState.isOpen).pipe(map((isOpen) => isOpen(this.type, this.messageId)));
      this.messageInfo$ = this.store.select(SamwinMessageListStateSelectors.getMessageById).pipe(map((getMessageById) => getMessageById(this.messageId)));
      this.messageInfo$
         .pipe(
            tap((messageInfo) => (this.skillTreeIcon = MailingFolderEnum[messageInfo?.group]?.icon ?? this.envelope)),
            takeUntil(this.destroy$)
         )
         .subscribe();
   }

   onClick(messageId: string) {
      const index = this.store.selectSnapshot(SamwebWindowState.getHighestIndex);
      this.store.dispatch(new SetWindowIndex(this.type, this.messageId, index + 1));
      this.store.dispatch(new RestoreWindow(this.type, this.messageId));
   }

   htmlToText(html: string) {
      const tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
   }
}
